import React, { useState, useEffect } from 'react';
import './CataloguePopup.css';

// Google Drive direct download link
const CATALOGUE_LINK =
  'https://drive.google.com/uc?export=download&id=1buzNLVYSZ3GA-3Ne3eWWmlFbIyqay8kH';

// Delay before popup appears (ms)
const POPUP_DELAY = 1500;

// localStorage key — show popup only once per session
const STORAGE_KEY = 'catalogue_popup_shown';

const CataloguePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show once per browser session
    const alreadyShown = sessionStorage.getItem(STORAGE_KEY);
    if (alreadyShown) return;

    const timer = setTimeout(() => {
      setVisible(true);
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }, POPUP_DELAY);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => setVisible(false);

  // Close on backdrop click
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  if (!visible) return null;

  return (
    <div
      className="catalogue-backdrop"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="catalogue-popup-title"
    >
      <div className="catalogue-popup">
        {/* Close button */}
        <button
          className="catalogue-close"
          onClick={handleClose}
          aria-label="Close popup"
        >
          &times;
        </button>

        {/* Icon */}
        <div className="catalogue-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="64" height="64" rx="12" fill="#1a2d4e" />
            <path
              d="M20 14h16l8 8v28a2 2 0 01-2 2H20a2 2 0 01-2-2V16a2 2 0 012-2z"
              fill="white"
              fillOpacity="0.15"
              stroke="white"
              strokeWidth="2"
            />
            <path d="M36 14v8h8" stroke="white" strokeWidth="2" strokeLinejoin="round" />
            <path
              d="M32 30v12M27 37l5 5 5-5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Content */}
        <h2 id="catalogue-popup-title">Download Our Catalogue</h2>
        <p>
          Explore our complete range of medical products — surgical dressings,
          bandages, gauze, and more. Get full specifications, sizes, and
          product details in one place.
        </p>

        {/* Download button */}
        <a
          href={CATALOGUE_LINK}
          download="Karim Industries Catalogue.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="catalogue-download-btn"
          onClick={handleClose}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 3v13M7 11l5 5 5-5" />
            <path d="M4 20h16" />
          </svg>
          Download Catalogue
        </a>

        {/* Skip link */}
        <button className="catalogue-skip" onClick={handleClose}>
          No thanks, continue browsing
        </button>
      </div>
    </div>
  );
};

export default CataloguePopup;
